import "./CheckboxBtnv1.styles.scss";
import React, { useState } from "react";
const Checkbox = ({ id, label, onChange }) => {
  const [isActive, setIsActive] = useState(false);
  const handleChange = (e) => {
    setIsActive(e.target.checked);
    onChange(e);
  };
  return (
    <React.Fragment>
      <input
        id={id}
        type="checkbox"
        onChange={(e) => {
          handleChange(e);
        }}
        style={{ marginRight: "10px" }}
      />
      <label htmlFor={id} className={isActive ? "sm-label white" : "sm-label"}>
        {label}
      </label>
    </React.Fragment>
  );
};
const LargeCheckbox = ({ id, label, onChange }) => {
  const [isActive, setIsActive] = useState(false);

  const handleChange = (e) => {
    setIsActive(e.target.checked);
    onChange(e);
  };
  return (
    <React.Fragment>
      <input
        className="large-checkbox"
        id={id}
        type="checkbox"
        onChange={(e) => {
          handleChange(e);
        }}
        style={{ marginRight: "15px" }}
      />
      <label
        htmlFor={id}
        className={isActive ? "sm-label large white" : "sm-label large"}
      >
        {label}
      </label>
    </React.Fragment>
  );
};
export default Checkbox;
export { LargeCheckbox };
